import { action, observable, makeObservable } from "mobx";
import EmployeeAPI from "../api/EmployeeAPI";
import { Employee, Resetpassword } from "../models/Employees/Employee";
import { GetEmployeeParams } from "../models/Employees/GetEmployeeParams";
import { EmployeeDetails, Team } from "../models/Employees/EmployeeDetails";
import { EmployeePermisson } from "../models/Employees/EmployeePermisson";
import { EmployeeTeam } from "../models/Employees/EmployeeTeam";
export class EmployeeStore {
  employeeAPI: EmployeeAPI;
  limit: number;
  total_pages: number;
  total_count: number;
  employees: Employee[];
  employeeDetails?: Employee;
  editedEmployees?: Employee;
  error: string | null = null;
  teamPermissions: EmployeePermisson[] = [];
  getTeam: Team[] = [];
  adminPermissionList: EmployeePermisson[] = [];
  employeeData: EmployeeDetails[] = [];

  constructor() {
    this.employeeAPI = new EmployeeAPI();
    this.employees = [];
    this.teamPermissions = [];
    this.getTeam = [];
    this.adminPermissionList = [];
    this.employeeData = [];
    this.limit = 0;
    this.total_pages = 0;
    this.total_count = 0;

    makeObservable(this, {
      employees: observable,
      getEmployee: action,
      editEmployee: action,
      error: observable,
      teamPermissions: observable,
      getTeam: observable,
      adminPermissionList: observable,
      employeeDetails: observable,
      editedEmployees: observable,
      removeEmployeeDetails: action,
      reset: action,
    });
  }

  reset = () => {
    this.employees = [];
    this.teamPermissions = [];
    this.getTeam = [];
    this.adminPermissionList = [];
    this.employeeData = [];
    this.limit = 0;
    this.total_pages = 0;
    this.total_count = 0;
  };

  setLoadingAndError = action((errorMessage: string | null) => {
    this.error = errorMessage;
  });

  fetchEmployee = async (params: GetEmployeeParams) => {
    try {
      this.employees = [];
      const response = await this.employeeAPI.fetchEmployee(params);
      this.limit = response.limit;
      this.total_pages = response.total_pages;
      this.total_count = response.total_count;
      this.employees = response.list;

      return response;
    } catch (error: any) {
      throw error;
    }
  };

  getEmployee = async (params: GetEmployeeParams) => {
    try {
      this.employees = [];
      const response = await this.employeeAPI.getEmployee(params);
      this.limit = response.limit;
      this.total_pages = response.total_pages;
      this.total_count = response.total_count;
      this.employees = response.list;

      return response;
    } catch (error: any) {
      throw error;
    }
  };

  editEmployee = async (employeeId: number, employee: Employee) => {
    try {
      const response = await this.employeeAPI.editEmployee(employee);
      if (response.success && this.employees) {
        const index = this.employees.findIndex(
          (item) => item.id === employeeId
        );
        if (index !== -1 && employee) {
          this.employees[index] = employee;
        }
      }
      return response;
    } catch (error: any) {
      throw error;
    }
  };

  getEmployeeDetails = async (adminId: number) => {
    try {
      const response = await this.employeeAPI.getAdminDetails(adminId);
      this.employeeDetails = response.result as Employee;
    } catch (error: any) {
      throw error;
    }
  };

  removeEmployeeDetails = () => {
    this.employeeDetails = undefined;
  };

  getTeamPermission = async (employeeId: number) => {
    try {
      const response = await this.employeeAPI.teamPermission(employeeId);
      this.teamPermissions = response.result as EmployeePermisson[];
    } catch (error: any) {
      throw error;
    }
  };
  getAllTeam = async () => {
    try {
      const response = await this.employeeAPI.getAllTeam();
      this.getTeam = response.result as EmployeeTeam[];
    } catch (error: any) {
      throw error;
    }
  };

  addEmployee = async (employeeDetails: Employee) => {
    try {
      const response = await this.employeeAPI.addEmployee(employeeDetails);
      return response;
    } catch (error: any) {
      throw error;
    }
  };

  resetPassword = async (email: Resetpassword) => {
    try {
      const response = await this.employeeAPI.resetPassword(email);
      return response;
    } catch (error: any) {
      throw error;
    }
  };

  deleteEmployee = async (employeeId: number) => {
    try {
      const response = await this.employeeAPI.deleteEmployee(employeeId);
      return response;
    } catch (error: any) {
      throw error;
    }
  };
}
